import { render, staticRenderFns } from "./standards-query.vue?vue&type=template&id=44f90a26&scoped=true"
import script from "./standards-query.vue?vue&type=script&lang=js"
export * from "./standards-query.vue?vue&type=script&lang=js"
import style0 from "./standards-query.vue?vue&type=style&index=0&id=44f90a26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f90a26",
  null
  
)

export default component.exports